// @ts-nocheck
import {
  getUniversalDateTimeFormat,
  phoneNumberFormat,
} from "../../appCalcutions";
import { getCssVariableHandler } from "./getCssVariables";

/**
 * default styles modal which i generally use
 */
export const defaultModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 4,
  minWidth: "700px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  "@media (max-width: 600px)": {
    minWidth: "96vw",
    maxHeight: "96vh",
    width: "97vw",
    overflowY: "auto",
  },
};

export function generateDateTableForReimWarning({
  isReimb,
  list,
  message,
  isLastCont,
  contList,
  lastContMessage,
}) {
  if (!list && !contList) return null;

  const border = getCssVariableHandler({ variableName: "--primary-pink-hex" });
  let html = "";
  if (isReimb) {
    html += `
<h4 style="color: white; text-align: left; margin-top: 0px; font-weight:400;">${message ?? "No Title"}</h4>
<table style="border-collapse: collapse; width: 100%; text-align: center; color: white; margin-bottom: 20px;">
<thead>
<tr>
<th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Position Name</th>
<th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Date</th>
</tr>
</thead>
<tbody>
`;

    list?.forEach((value) => {
      html += `
<tr>
<td style="border: 1px solid ${border}; padding: 5px;">${value?.positionName}${value?.positionOrder ? `-${value?.positionOrder}` : ""}</td>
<td style="border: 1px solid ${border}; padding: 5px;">${getUniversalDateTimeFormat({ dateTime: value?.startDate }) ?? "N/A"}</td>
</tr>
`;
    });

    html += `</tbody></table>`;
  }

  if (isLastCont) {
    html += `
            <h4 style="color: white; text-align: left; margin-top: 0px; font-weight:400;">${lastContMessage ?? "No Title"}</h4>
            <table style="border-collapse: collapse; width: 100%; text-align: center; color: white; margin-bottom: 20px;">
                <thead>
                    <tr>
                        <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Contractor Name</th>
                        <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Phone No.</th>
                        <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Email</th>
                    </tr>
                </thead>
                <tbody>
        `;

    contList?.forEach((value) => {
      html += `
                <tr>
                    <td style="border: 1px solid ${border}; padding: 5px;">${value?.contractorName}</td>
                    <td style="border: 1px solid ${border}; padding: 5px;">${phoneNumberFormat(value?.mobile)}</td>
                    <td style="border: 1px solid ${border}; padding: 5px;">${value?.email}</td>
                </tr>
            `;
    });

    html += `</tbody></table>`;
  }

  return html || null;
}

export const generateBulkUpdateResultHTML = ({
  summary,
  errors,
  successes,
  additionalHeader,
  additionalMessage,
  isPOUpdate = false,
}) => {
  let html = "";

  if (additionalHeader) {
    html += `
      <div style="margin-bottom: 16px;">
        <h3 style="margin: 0 0 8px 0; font-size: 1.1rem; font-weight: 600; color: #fff;">${additionalHeader}</h3>
      </div>
    `;
  }

  if (additionalMessage) {
    html += `
      <div style="margin-bottom: 16px;">
        <p style="margin: 0; font-size: 0.875rem; color: rgba(255, 255, 255, 0.8);">${additionalMessage}</p>
      </div>
    `;
  }

  if (summary) {
    const successCount = !isPOUpdate
      ? summary?.successfullyUpdated
      : summary?.updated;
    const failureCount = !isPOUpdate ? summary?.failedCount : summary?.failed;
    const alreadyUpdated = !isPOUpdate ? summary?.alreadyUpdated : null;

    // Fixed: Proper style attribute syntax
    const gridStyle = isPOUpdate
      ? "display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; margin-bottom: 16px;"
      : "display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 16px;";

    html += `<div style="${gridStyle}">`;

    // No Changes card (only for non-PO updates)
    if (!isPOUpdate) {
      html += `
        <div style="background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 8px; padding: 12px; text-align: center; display:flex; justify-content:center; align-items: center; gap:0.5rem;">
          <div style="font-size: 1.5rem; font-weight: 700; color: #fff; margin-bottom: 4px;">${alreadyUpdated}</div>
          <div style="font-size: 0.75rem; color: rgba(255, 255, 255, 0.6); text-transform: uppercase; letter-spacing: 0.5px;">No Changes</div>
        </div>
      `;
    }

    // Successful card
    html += `
      <div style="background: rgba(97, 196, 89, 0.1); border: 1px solid rgba(97, 196, 89, 0.3); border-radius: 8px; padding: 8px; text-align: center; display:flex; justify-content:center; align-items: center; gap:0.5rem;">
        <div style="font-size: 1.5rem; font-weight: 700; color: #97C459; margin-bottom: 4px;">${successCount}</div>
        <div style="font-size: 1rem; color: rgba(97, 196, 89, 0.8); text-transform: uppercase; letter-spacing: 0.5px;">Successful</div>
      </div>
    `;

    // Failed card
    html += `
      <div style="background: rgba(240, 149, 149, 0.1); border: 1px solid rgba(240, 149, 149, 0.3); border-radius: 8px; padding: 8px; text-align: center;display:flex; justify-content:center; align-items: center; gap:0.5rem;">
        <div style="font-size: 1.5rem; font-weight: 700; color: #F09595; margin-bottom: 4px;">${failureCount}</div>
        <div style="font-size: 1rem; color: rgba(240, 149, 149, 0.8); text-transform: uppercase; letter-spacing: 0.5px;">Failed</div>
      </div>
    `;

    html += `</div>`;
  }

  const primaryPink = getCssVariableHandler({
    variableName: "--primary-pink-hex",
  });
  const primaryGreen = getCssVariableHandler({
    variableName: "--primary-green-hex",
  });
  const primaryWhite = getCssVariableHandler({ variableName: "--white-rgb" });

  // Success Table
  if (successes && successes.length > 0) {
    const successExportFunction = isPOUpdate
      ? "window.exportPOSuccessesToCSV && window.exportPOSuccessesToCSV()"
      : "window.exportSuccessesToCSV && window.exportSuccessesToCSV()";

    html += `
      <div style="margin-top: 16px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
          <h4 style="margin: 0; font-size: 0.95rem; font-weight: 600; color: #97C459;">Success Details:</h4>
          <button 
            onclick="${successExportFunction}"
            style="background: rgba(97, 196, 89, 0.2); border: 1px solid rgba(97, 196, 89, 0.5); color: #97C459; padding: 6px 12px; border-radius: 6px; cursor: pointer; font-size: 0.8rem; font-weight: 500; transition: all 0.2s;"
            onmouseover="this.style.background='rgba(97, 196, 89, 0.3)'"
            onmouseout="this.style.background='rgba(97, 196, 89, 0.2)'"
          >
            Export to CSV
          </button>
        </div>
        <div style="max-height: 400px; overflow-y: auto; border: 1px solid ${primaryGreen}; border-radius: 8px; background-color: rgba(97, 196, 89, 0.05);" class="custom-scroll-design">
          <table style="width: 100%; border-collapse: collapse; font-family: inherit;">
            <thead>
              <tr>
                <th style="position: sticky; top: 0; background-color: ${primaryGreen}; color: ${primaryWhite}; font-weight: 600; font-size: 0.875rem; padding: 12px; text-align: left; border-bottom: 1px solid rgba(97, 196, 89, 0.3); z-index: 1; white-space:nowrap;">Profile ID</th>
                <th style="position: sticky; top: 0; background-color: ${primaryGreen}; color: ${primaryWhite}; font-weight: 600; font-size: 0.875rem; padding: 12px; text-align: left; border-bottom: 1px solid rgba(97, 196, 89, 0.3); z-index: 1;white-space:nowrap;">Name</th>
                <th style="position: sticky; top: 0; background-color: ${primaryGreen}; color: ${primaryWhite}; font-weight: 600; font-size: 0.875rem; padding: 12px; text-align: left; border-bottom: 1px solid rgba(97, 196, 89, 0.3); z-index: 1;white-space:nowrap;">Updates</th>
              </tr>
            </thead>
            <tbody>
              ${successes
                .map((success) => {
                  const successList = Array.isArray(success.successes)
                    ? success.successes
                    : success.success
                      ? [success.success]
                      : [];

                  const successHTML =
                    successList.length > 0
                      ? `<ul style="margin: 0; padding-left: 20px; list-style-type: disc;">
                          ${successList.map((msg) => `<li style="margin-bottom: 4px;">${msg}</li>`).join("")}
                         </ul>`
                      : '<span style="color: rgba(255, 255, 255, 0.5);">No details</span>';

                  return `
                    <tr>
                      <td style="color: #fff; font-size: 0.875rem; padding: 12px; border-bottom: 1px solid rgba(255, 255, 255, 0.05); vertical-align: top;">${success.profileId}</td>
                      <td style="color: #fff; font-size: 0.875rem; padding: 12px; border-bottom: 1px solid rgba(255, 255, 255, 0.05); vertical-align: top;">${success.name}</td>
                      <td style="color: #97C459; font-size: 0.875rem; padding: 12px; border-bottom: 1px solid rgba(255, 255, 255, 0.05); vertical-align: top;">${successHTML}</td>
                    </tr>
                  `;
                })
                .join("")}
            </tbody>
          </table>
        </div>
      </div>
    `;
  }

  // Error Table
  if (errors && errors.length > 0) {
    const errorExportFunction = isPOUpdate
      ? "window.exportPOErrorsToCSV && window.exportPOErrorsToCSV()"
      : "window.exportErrorsToCSV && window.exportErrorsToCSV()";

    html += `
      <div style="margin-top: 16px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
          <h4 style="margin: 0; font-size: 0.95rem; font-weight: 600; color: #F09595;">Error Details:</h4>
          <button 
            onclick="${errorExportFunction}"
            style="background: rgba(240, 149, 149, 0.2); border: 1px solid rgba(240, 149, 149, 0.5); color: #F09595; padding: 6px 12px; border-radius: 6px; cursor: pointer; font-size: 0.8rem; font-weight: 500; transition: all 0.2s;"
            onmouseover="this.style.background='rgba(240, 149, 149, 0.3)'"
            onmouseout="this.style.background='rgba(240, 149, 149, 0.2)'"
          >
            Export to CSV
          </button>
        </div>
        <div style="max-height: 400px; overflow-y: auto; border: 1px solid ${primaryPink}; border-radius: 8px; background-color: rgba(240, 149, 149, 0.05);" class="custom-scroll-design">
          <table style="width: 100%; border-collapse: collapse; font-family: inherit;">
            <thead>
              <tr>
                <th style="position: sticky; top: 0; background-color: ${primaryPink}; color: ${primaryWhite}; font-weight: 600; font-size: 0.875rem; padding: 12px; text-align: left; border-bottom: 1px solid rgba(240, 149, 149, 0.3); z-index: 1; white-space:nowrap;">Profile ID</th>
                <th style="position: sticky; top: 0; background-color: ${primaryPink}; color: ${primaryWhite}; font-weight: 600; font-size: 0.875rem; padding: 12px; text-align: left; border-bottom: 1px solid rgba(240, 149, 149, 0.3); z-index: 1;white-space:nowrap;">Name</th>
                <th style="position: sticky; top: 0; background-color: ${primaryPink}; color: ${primaryWhite}; font-weight: 600; font-size: 0.875rem; padding: 12px; text-align: left; border-bottom: 1px solid rgba(240, 149, 149, 0.3); z-index: 1;white-space:nowrap;">Errors</th>
              </tr>
            </thead>
            <tbody>
              ${errors
                .map((error) => {
                  const errorList = Array.isArray(error.errors)
                    ? error.errors
                    : error.error
                      ? [error.error]
                      : [];

                  const errorHTML =
                    errorList.length > 0
                      ? `<ul style="margin: 0; padding-left: 20px; list-style-type: disc;">
                          ${errorList.map((err) => `<li style="margin-bottom: 4px;">${err}</li>`).join("")}
                         </ul>`
                      : '<span style="color: rgba(255, 255, 255, 0.5);">No error details</span>';

                  return `
                    <tr>
                      <td style="color: #fff; font-size: 0.875rem; padding: 12px; border-bottom: 1px solid rgba(255, 255, 255, 0.05); vertical-align: top;">${error.profileId}</td>
                      <td style="color: #fff; font-size: 0.875rem; padding: 12px; border-bottom: 1px solid rgba(255, 255, 255, 0.05); vertical-align: top;">${error.name}</td>
                      <td style="color: #F09595; font-size: 0.875rem; padding: 12px; border-bottom: 1px solid rgba(255, 255, 255, 0.05); vertical-align: top;">${errorHTML}</td>
                    </tr>
                  `;
                })
                .join("")}
            </tbody>
          </table>
        </div>
      </div>
    `;
  }

  return html;
};